import { useContext } from 'react';

import { useNavigate } from 'react-router';

import { buildQueryString } from '../../utils/queryParams';
import { RouteContext } from '../routes';

export const useNavigateToBasePath = () => {
  const queryString = buildQueryString();
  const { basePath } = useContext(RouteContext);
  const navigate = useNavigate();
  return () => navigate(`${basePath}/${queryString}`);
};
